<template>
    <div
        class="progress-bar"
        :class="progressBarClasses">
        <div
            class="progress-bar__progress"
            :style="{ 'width': progress + '%' }">
            {{ progress / 100 | percent }}
        </div>
    </div>
</template>

<script>
    /**
     * Progress Bar Component
     */
    export default {
        name: 'progress_bar',
        props: {
            success: {
                type: Boolean,
                required: true,
                default: false
            },
            error: {
                type: Boolean,
                required: true,
                default: false
            },
            progress: {
                type: Number,
                required: true,
                default: 0
            }
        },
        computed: {
            progressBarClasses () {
                return {
                    'progress-bar--success': this.success,
                    'progress-bar--danger': this.error
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "../../styles/_variables.scss";

    .progress-bar {
        position: relative;
        height: 8px;
        border-radius: 50px;
        overflow: hidden;
        background: #EEE;

        &__progress {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            text-indent: -9999px;
            transition: all .4s ease;
            background: $light-blue;
            border-radius: 50px;
        }

        &--success {
            .progress-bar__progress { background: $success-color; }
        }

        &--danger {
            .progress-bar__progress { background: $danger-color; }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/general/ProgressBar.vue